import { useMemo } from "react";
import { useAppSelector } from "../../hooks/storeHooks";
import { formatDefectId } from "@idwal/idwal-utilities/lib/helpers";
import { Tooltip } from "primereact/tooltip";
import { selectPositiveItemFailed } from "../../store/selectors/positiveItemSelectors";
import { PositiveItem } from "../../types/positiveItem";

export const PositiveItemIdBody = (positiveItem: PositiveItem) => {

    const failed = useAppSelector(selectPositiveItemFailed);

    const hasFailed = useMemo(() => (
        failed.includes(positiveItem.id)
    ), [failed]);
     
    return (
        <span className="flex justify-content-left align-items-center">
            {formatDefectId(positiveItem.id)}
            {hasFailed ? (
                <>
                <Tooltip target=".table-item-failed" />
                <span 
                    className="pi pi-exclamation-circle ml-2 table-item-failed"
                    data-pr-tooltip="Failed to update. Please retry."
                    data-pr-position="right"
                    data-pr-my="left center-2"
                />
                </>
            ) : null}
        </span>
    );
}